import React, { useState } from 'react';
import {ProgressSpinner} from "primereact/progressspinner";

function IframeWithSpinner({ src }: { src: string }) {
    const [loading, setLoading] = useState(true);

    const handleLoad = () => {
        setLoading(false);
        console.log("Loading frame");
    };

    return (
        <div style={{ position: 'relative', width: '100%', height: '500px' }}>
            {loading && (
                <ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" className="flex" />
            )}
            <iframe
                src={src} // Usamos el prop src para la URL del iframe
                style={{ width: '100%', height: '100%', border: 'none', display: loading ? 'none' : 'block' }}
                onLoad={handleLoad}
            />
        </div>
    );
}

export default IframeWithSpinner;
